import {
  Body,
  InputAdornment,
  MaterialIcons,
  MaterialUICore,
  Select,
} from '@iclinic/design-system';
import React, { useState } from 'react';
import { LocalVideoTrack } from 'twilio-video';

import {
  DEFAULT_VIDEO_CONSTRAINTS,
  SELECTED_VIDEO_INPUT_KEY,
  selectDevices,
} from 'features/video-conference/constants';
import useDevices from 'features/video-conference/hooks/useDevices';
import useMediaStreamTrack from 'features/video-conference/hooks/useMediaStreamTrack';
import { useConference } from 'features/video-conference/state/conferenceContext';
import useStyles from '../styles';

const { MenuItem } = MaterialUICore;
const { Videocam } = MaterialIcons;

export default function VideoInputList() {
  const classes = useStyles({});
  const { videoInputDevices } = useDevices();
  const { localTracks } = useConference();

  const localVideoTrack = localTracks.find(
    (track) => track.kind === 'video',
  ) as LocalVideoTrack | undefined;
  const mediaStreamTrack = useMediaStreamTrack(localVideoTrack);
  const [storedLocalVideoDeviceId, setStoredLocalVideoDeviceId] = useState(
    window.localStorage.getItem(SELECTED_VIDEO_INPUT_KEY),
  );
  const localVideoInputDeviceId =
    mediaStreamTrack?.getSettings().deviceId ||
    storedLocalVideoDeviceId ||
    videoInputDevices[0]?.deviceId;

  function replaceTrack(newDeviceId: string) {
    setStoredLocalVideoDeviceId(newDeviceId);
    window.localStorage.setItem(SELECTED_VIDEO_INPUT_KEY, newDeviceId);
    localVideoTrack
      ?.restart({
        ...(DEFAULT_VIDEO_CONSTRAINTS as {}),
        deviceId: { exact: newDeviceId },
      })
      .catch(() => {});
  }

  return (
    <div>
      {videoInputDevices.length > 0 ? (
        <Select
          onChange={(e) => replaceTrack(e.target.value as string)}
          value={localVideoInputDeviceId || ''}
          data-testid="select"
          InputProps={{
            id: 'audio-input-list',
            startAdornment: (
              <InputAdornment position="start">
                <Videocam className={classes.iconColor} />
              </InputAdornment>
            ),
          }}
          label={selectDevices.VIDEO_INPUT}
        >
          {videoInputDevices.map((device) => (
            <MenuItem value={device.deviceId} key={device.deviceId} selected>
              {device.label}
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Body variant="xs" bold>
          {selectDevices.VIDEO_NOT_FOUND}
        </Body>
      )}
    </div>
  );
}
